import dom from "../../../../dist/jsx-render/dom";
import JSXComponent from "../../../../dist/jsx-render/JSXComponent";
import { PopupTextComponent } from "./PopupTextComponent";
import { DynPopup } from "../../../Components/DynPopup";
import { WidgetDesignMeasureText } from "../Widgets/WidgetDesignMeasureText";
import { TextComponent } from "../../../Components/TextComponent";
import { AceEditorComponent } from "../../../Components/AceEditorComponent";

export type PopupDesignMeasureTextComponentProps = {
    widget: WidgetDesignMeasureText;
}

export class PopupDesignMeasureTextComponent extends JSXComponent {
    props: PopupDesignMeasureTextComponentProps;
    markup: string;
    styles: string;
    json: string;
    clientId: string;
    permissionCheckUrl: string;

    constructor(props: PopupDesignMeasureTextComponentProps) {
        super(props);

        this.markup = this.props.widget.props.markup;
        this.styles = this.props.widget.props.styles;
        this.json = this.props.widget.props.json;
        this.clientId = this.props.widget.props.clientId;
        this.permissionCheckUrl = this.props.widget.props.permissionCheckUrl;
    }

    onSave = (): boolean => {
        this.props.widget.props.markup = this.markup;
        this.props.widget.props.styles = this.styles;
        this.props.widget.props.clientId = this.clientId;
        this.props.widget.props.json = this.json;
        this.props.widget.props.permissionCheckUrl = this.permissionCheckUrl;

        this.props.widget.recreate();
        return true;
    }

    element: HTMLElement;
    getElement = () => {
        this.element =
            <DynPopup size="fullscreen" showCancelButton={true} showSaveButton={true} onSave={this.onSave}
                title={Resources['WidgetClient'].widgetDesignMeasureText}>
                <div className="d-flex flex-column h-100">
                    <ul class="nav nav-tabs" id="myTab" role="tablist">
                        <li class="nav-item" role="presentation">
                            <a class="nav-link active" id="settings-tab" data-toggle="tab" href="#settings" role="tab" aria-controls="settings" aria-selected="true">{Resources["WidgetClient"].tabSettings}</a>
                        </li>
                        <li class="nav-item" role="presentation">
                            <a class="nav-link" id="design-tab" data-toggle="tab" href="#design" role="tab" aria-controls="design" aria-selected="false">{Resources["WidgetClient"].designHtml}</a>
                        </li>
                        <li class="nav-item" role="presentation">
                            <a class="nav-link" id="styles-tab" data-toggle="tab" href="#styles" role="tab" aria-controls="styles" aria-selected="false">{Resources["WidgetClient"].styles}</a>
                        </li>
                        <li class="nav-item" role="presentation">
                            <a class="nav-link" id="json-tab" data-toggle="tab" href="#json" role="tab" aria-controls="json" aria-selected="false">{Resources["WidgetClient"].json}</a>
                        </li>
                    </ul>
                    <div class="tab-content mt-2 flex-grow-1" id="myTabContent">
                        <div class="tab-pane fade h-100 show active" id="settings" role="tabpanel" aria-labelledby="settings-tab">
                        <TextComponent model={this} field="clientId" name={Resources["WidgetClient"].clientId} />
                        <TextComponent model={this} field="permissionCheckUrl" name={Resources["WidgetClient"].permissionCheckUrl} />
                        </div>
                        <div class="tab-pane fade h-100" id="design" role="tabpanel" aria-labelledby="design-tab">
                            {this.renderMarkupEditor()}
                        </div>
                        <div class="tab-pane fade h-100" id="styles" role="tabpanel" aria-labelledby="styles-tab">
                            {this.renderStylesEditor()}
                        </div>
                        <div class="tab-pane fade h-100" id="json" role="tabpanel" aria-labelledby="json-tab">
                            {this.renderJsonEditor()}
                        </div>
                    </div>
                </div>
            </DynPopup>;
    }

    renderMarkupEditor(): HTMLElement {
        return <div className="markup-editor h-100 d-flex flex-column">
            <div className="position-relative flex-grow-1">
                <AceEditorComponent model={this} field="markup" isCss={false} />
            </div>
            <div className="info mt-1">
                {"Daten aus der Maßnahme mit Platzhaltern im Format [UniqueId] anzeigen."}
            </div>
        </div>;
    }

    renderStylesEditor(): HTMLElement {
        return <div className="styles-editor h-100 d-flex flex-column">
            <div className="position-relative flex-grow-1">
                <AceEditorComponent model={this} field="styles" isCss={true} />
            </div>
        </div>;
    }

    renderJsonEditor(): HTMLElement {
        return <div className="styles-editor h-100 d-flex flex-column">
            <div className="position-relative flex-grow-1">
                <AceEditorComponent model={this} field="json" isCss={false} isJson={true} />
            </div>
            <div className="info mt-1">
                {"Lokalisierte Texte als Json-Objekt. Format: \"key\": { \"de\": \"Text\", \"en\": \"Text\", ... }. Verwenden im Markup mit [localize:key]."}
            </div>
        </div>;
    }


    render(): HTMLElement {
        this.getElement();
        return this.element;
    }
}